/**
 * Scopes OAuth da Google Health API v4 (somente leitura).
 * @see https://developers.google.com/health/reference/rest/v4/users.dataTypes.dataPoints/list
 */
export const GOOGLE_HEALTHCARE_SCOPES = [
  "https://www.googleapis.com/auth/googlehealth.activity_and_fitness.readonly",
  "https://www.googleapis.com/auth/googlehealth.health_metrics_and_measurements.readonly",
  "https://www.googleapis.com/auth/googlehealth.sleep.readonly",
  "https://www.googleapis.com/auth/googlehealth.ecg.readonly",
] as const;

export const GOOGLE_HEALTHCARE_SCOPE_STRING = GOOGLE_HEALTHCARE_SCOPES.join(" ");
